import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import defaultBg from 'assets/images/default-bg.jpg'
import { FEATURED_VIDEOS } from 'constants/appConstants'
import { contentTypeMap, contentTypesNames } from 'interfaces/contentTypeInterface'
import { Icon } from 'components/atoms'
import { PlayIcon } from 'assets/icons'
import * as S from './styled'

const GenericCard = ({ item, itemHeight, contentType, featured, handleStatus = () => {} }) => {
  const [isVideo, setIsVideo] = useState(false)
  const itemObject = contentTypeMap(contentType, item)

  useEffect(() => {
    if (contentType === FEATURED_VIDEOS) setIsVideo(true)
  })

  return (
    <S.CardContainer itemHeight={itemHeight} featured={featured} onClick={() => handleStatus(false)}>
      <img
        src={!itemObject.previewImage ? defaultBg : itemObject.previewImage}
        alt={itemObject.altText && itemObject.altText}
      />
      <S.Gradient />
      {isVideo && (
        <S.IconContainer>
          <Icon Source={PlayIcon} width='20.67px' height='23.17px' />
        </S.IconContainer>
      )}
      <S.Title>{itemObject.name}</S.Title>
      {featured && (
        <S.ContentTypeFlag>
          <span>{contentTypesNames(contentType, true)}</span>
        </S.ContentTypeFlag>
      )}
    </S.CardContainer>
  )
}

GenericCard.defaultProps = {
  itemHeight: '',
  featured: false,
  handleStatus: () => {},
}

GenericCard.propTypes = {
  item: PropTypes.object.isRequired,
  itemHeight: PropTypes.string,
  contentType: PropTypes.string.isRequired,
  featured: PropTypes.bool,
  handleStatus: PropTypes.func,
}

export default GenericCard
